import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import styles from './styles';

type RBISuccessPopupProps = {
    isOpen: boolean;
    messageHeader?: string;
    message?: string | Element | React.ReactFragment;
    cleanUp?: Function;
    closeModal: Function
}

export default function RBISuccessPopup(props: RBISuccessPopupProps) {
    const classes = styles();
    const { t } = useTranslation();

    const {
        isOpen,
        message: messageText,
        messageHeader,
        cleanUp: cleanUpFunction,
        closeModal
    } = props;

    const handleCloseModal = (): void => {
        if (cleanUpFunction) cleanUpFunction();
        closeModal();
    };

    return (
        <Dialog onClose={handleCloseModal} aria-labelledby="customized-dialog-title" open={isOpen} disableBackdropClick={true} className={classes.viewModal}>
            <DialogTitle id="customized-dialog-title" className={classes.successTitle}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {messageHeader ? t(messageHeader) : t('operationHours.error.headerText')}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <IconButton
                            style={{ padding: 0 }}
                            onClick={handleCloseModal}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent className={classes.modalContent}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    spacing={2}
                    style={{ width: "100%", height: "100%", alignSelf: "center" }}
                >
                    <Grid item xs={10} style={{ textAlign: "start" }}>
                        <Typography variant="body1">{messageText} </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.panel}>
                <Button
                    variant="contained"
                    className={classes.button}
                    color="primary" autoFocus onClick={handleCloseModal}>
                    {t('app.common.close')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}